export const talentsLegalUpdated = [
  {
    id: 164,
    name: '乔俊豪',
    role: '食品标签合规审核员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20food%20labeling%20compliance%20auditor%20in%20formal%20business%20attire%20with%20food%20safety%20documents%20and%20regulatory%20guidelines%20clean%20simple%20background%20corporate%20headshot%20style%20meticulous%20expression%20age%2035%20realistic%20photography&width=400&height=600&seq=talent-164&orientation=portrait',
    salary: '¥2250/月',
    tags: ['标签审核', '营养标签', '法规合规', '文字审核', '图案审核', '风险提示'],
    description: '负责食品包装标签、文字、图案的法规符合性审核，擅长标签要素完整性检查和营养标签合规审核。',
    skills: [
      { name: '标签要素检查', level: 97 },
      { name: '营养标签审核', level: 96 },
      { name: '文字用语规范', level: 95 },
      { name: '图案版面合规', level: 94 },
      { name: '法规库更新', level: 93 },
    ],
    performance: {
      monthly_audits: 500,
      compliance_rate: '98%',
    },
    cases: [
      {
        title: '某食品企业标签审核',
        result: '审核食品标签800+个，发现并纠正不合规问题200+个，避免监管处罚，合规率从85%提升至98%',
        duration: '持续服务',
        tags: ['标签审核', '合规提升', '风险规避', '监管认可'],
      },
      {
        title: '某进口食品本地化审核',
        result: '审核进口食品中文标签，确保符合中国法规，100+款产品顺利通关，避免退运损失',
        duration: '3个月',
        tags: ['进口食品', '本地化', '通关顺利', '损失避免'],
      },
      {
        title: '某新品标签合规咨询',
        result: '为新品上市提供标签合规咨询，提前规避风险点，产品一次性通过审查，上市时间提前2周',
        duration: '1个月',
        tags: ['新品咨询', '风险规避', '审查通过', '上市提前'],
      },
    ],
    reviews: [
      {
        name: '康质量总监',
        company: '某食品企业',
        rating: 5,
        content: '乔俊豪的标签审核非常专业，他对食品法规的理解很深刻。他的审核帮我们避免了很多监管风险，合规率大幅提升。',
        date: '2024-01-30',
      },
      {
        name: '贺进口经理',
        company: '某进口食品公司',
        rating: 5,
        content: '他的进口食品标签审核非常细致，确保了我们的产品符合中国法规。他的工作让我们的产品顺利通关，避免了退运损失。',
        date: '2024-02-22',
      },
      {
        name: '鲁产品经理',
        company: '某食品品牌',
        rating: 5,
        content: '他的合规咨询非常及时，帮我们提前规避了风险。他的专业建议让我们的新品一次性通过审查，上市时间提前了。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '食品标签合规审核专家，专注于确保食品标签符合法律法规要求',
        personality: '细致严谨、责任心强、专业扎实、持续学习，能够准确识别标签合规风险',
        background: '食品科学或法律专业背景，精通食品安全法、标签法规、营养标签标准，熟悉食品行业监管要求',
      },
      mission: {
        duties: '负责标签要素完整性检查、营养标签合规审核、文字用语规范性审核、图案版面合规性、法规库自动更新、风险提示与修改建议、多版本比对、合规审核报告',
        goals: '确保食品标签合规，合规率达到98%以上，避免监管处罚，保护企业和消费者权益',
        collaboration: '与设计师确认标签设计，与法规部门对接标准，与企业沟通修改建议',
      },
      delivery: {
        example: '输出标签审核报告、不合规问题清单、修改建议、合规证明、风险提示',
        workflow: '1.标签接收 → 2.要素检查 → 3.营养标签审核 → 4.文字审核 → 5.图案审核 → 6.风险识别 → 7.报告输出',
        format: '提供审核报告、问题清单、修改建议、合规证明、风险提示等标准化交付物',
      },
      metrics: {
        quality: '审核准确率、合规率、风险识别率、响应速度、客户满意度',
        acceptance: '审核准确全面，合规率达标，风险识别及时，建议可行，客户认可',
        improvement: '持续学习法规更新，优化审核流程，完善风险库，提升审核效率',
      },
    },
  },
];
